"use client";
import React, { useState } from "react";
import FilterButton from "@/src/components/button/Jobs/FilterButton";

export const filterOptions = {
  contractType: {
    name: "Contract Type",
    name_ar: "نوع الوظيفة",
    data: [
      { name: "All", name_ar: "الكل", value: "" },
      { name: "Full-Time", name_ar: "دوام كامل", value: "0" },
      { name: "Part-Time", name_ar: "دوام جزئي", value: "1" },
      { name: "Internship", name_ar: "تدريب", value: "2" },
      { name: "Temporary", name_ar: "مؤقت", value: "3" },
      { name: "Freelance", name_ar: "حر", value: "Freelance" },
    ],
  },
  status: {
    name: "Status",
    name_ar: "الحالة",
    data: [
      { name: "All", name_ar: "لا شئ", value: "" },
      { name: "Active", name_ar: "نشط", value: "0" },
      { name: "Inactive", name_ar: "غير نشط", value: "1" },
    ],
  },
  level: {
    name: "Level",
    name_ar: "المستوى",
    data: [
      { name: "None", name_ar: "لا شيء", value: "" },
      { name: "Basic", name_ar: "أساسي", value: "1" },
      { name: "Intermediate", name_ar: "متوسط", value: "2" },
      { name: "Advanced", name_ar: "متقدم", value: "3" },
      { name: "Expert", name_ar: "خبير", value: "4" },
    ],
  },
};

export type FilterType = keyof typeof filterOptions;

export interface Filters {
  jobType: string;
  specialization: string;
  language: string;
  postDate: string;
  contractType: string;
  status: string;
  level: string;
  departmentId: string;
}

interface FilteringSectionProps {
  filters: Filters;
  onFilterChange: (filterName: FilterType, selectedOption: string) => void;
  onResetFilters: () => void;
}

const FilteringSection: React.FC<FilteringSectionProps> = ({
  filters,
  onFilterChange,
  onResetFilters,
}) => {
  const [openFilter, setOpenFilter] = useState<string | null>(null);
  const [restartFillter, setRestartFillter] = useState('');

  const lang =
    typeof window !== "undefined" ? window.location.pathname.split("/")[1] : "";
  const isArabic = lang === "ar";

  const handleToggle = (filterKey: string) => {
    setOpenFilter((prev) => (prev === filterKey ? null : filterKey));
  };

  return (
    <div className="mb-6">
      <div className="h-auto w-full justify-between items-center sm:gap-6 gap-3 inline-flex flex-wrap">
        <div className="sm:gap-6 gap-3 inline-flex flex-wrap">
          {(Object.keys(filterOptions) as FilterType[]).map((filterKey) => {
            const { name, name_ar, data } = filterOptions[filterKey];
            return (
              <FilterButton
                key={filterKey}
                text={isArabic ? name_ar : name}
                options={data}
                onSelect={(option) => {
                  onFilterChange(filterKey, option);
                  setOpenFilter(null); // Close dropdown after selection
                }}
                restartFillter={restartFillter}
                isOpen={openFilter === filterKey}
                onToggle={() => handleToggle(filterKey)}
              />
            );
          })}
        </div>
        <div className="sm:gap-6 gap-3 inline-flex flex-wrap">
            <button
              className="text-red-700 dark:text-red-500 sm:h-[52px] h-10 sm:px-6 px-4 py-3.5 rounded-2xl border border-red-500 flex justify-between sm:gap-2 gap-1 items-center cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800"
              onClick={() => {
                onResetFilters();
                setRestartFillter((prev) => prev + 1);
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#EA3323"><path d="M791-55 55-791l57-57 736 736-57 57ZM633-440l-80-80h167v80h-87ZM433-640l-80-80h487v80H433Zm-33 400v-80h160v80H400ZM240-440v-80h166v80H240ZM120-640v-80h86v80h-86Z"/></svg>
              {isArabic ? "إزالة جميع الفلاتر" : "Remove All Filters"}
            </button>
        </div>
      </div>

      {/* Remove All Filters Button */}
    </div>
  );
};

export default FilteringSection;
